import { withContext } from "@hilma/tools";

import { AuthContext } from "../context";
import { Auth } from "../types";

/**
 * Function that returns a Higher Order Component with the `AuthContext` value injected via the `auth` prop
 * @param Component the component you want to inject the `AuthContext` value into
 */
const withAuth = withContext({ auth: AuthContext as React.Context<Auth> });

export default withAuth;
